import { __rest, __spreadArray, __assign } from 'tslib';
import React, { useState, useRef } from 'react';
import { usePopper, mergeRefs } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import '../Pill/Pill.esm.js';
import { PillValue } from '../Pill/PillValue.esm.js';
import { Dropdown } from './Dropdown.esm.js';

/**
 * The DynamicListFilter allows a user to enter custom values for the filter.
 * It provides an input for the user to type in the value, which will be added
 * to a multiselect below.
 */
var DynamicListFilter = function (props) {
    var autoFocus = props.autoFocus, name = props.name, label = props.label, _a = props.items, initialItems = _a === void 0 ? [] : _a, onClose = props.onClose, _b = props.disabled, disabled = _b === void 0 ? false : _b, rest = __rest(props, ["autoFocus", "name", "label", "items", "onClose", "disabled"]);
    var _c = useFilters(), filters = _c.filters, setFilters = _c.setFilters;
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var currentFilters = filters[name] || [];
    var _e = useState(function () {
        return Array.from(new Set(__spreadArray(__spreadArray([], currentFilters, true), initialItems, true)));
    }), items = _e[0], setItems = _e[1];
    var anchorRef = useRef(null);
    var _f = usePopper({
        placement: "bottom-start",
        strategy: "fixed"
    }), triggerRef = _f.triggerRef, containerRef = _f.containerRef;
    var valueLabel = (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.length)
        ? currentFilters.join(", ")
        : "Enter ".concat(label);
    return (React.createElement(React.Fragment, null,
        React.createElement(PillValue, { addClassName: "tw-w-auto", onClose: onClose, autoFocus: autoFocus, labelKey: label, labelValue: valueLabel, ref: mergeRefs([triggerRef, anchorRef]), isOpen: isOpen, disabled: disabled, required: true, onMouseUp: function () { return setIsOpen(!isOpen); }, onKeyDown: function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    setIsOpen(true);
                }
            } }),
        isOpen && (React.createElement(Dropdown, __assign({}, rest, { onOpenChange: setIsOpen, anchorRef: anchorRef, containerRef: containerRef, label: label, items: items, selectedItems: currentFilters, addItem: function (item) { return setItems(__spreadArray([item], items, true)); }, setSelectedItems: function (items) {
                var _a;
                return setFilters((_a = {}, _a[name] = items, _a));
            } })))));
};

export { DynamicListFilter };
//# sourceMappingURL=DynamicListFilter.esm.js.map
